/** Alerts has a tab per kind of thing, `/alerts/<tab>`: what has been raised, and the rules that raise it. */
export const ALERTS_PATH = '/alerts';

export const ALERT_TABS = ['raised', 'rules'] as const;
export type AlertTab = (typeof ALERT_TABS)[number];

export const ALERT_TAB_LABELS: Record<AlertTab, string> = { raised: 'Raised', rules: 'Rules' };

export function alertTabPath(tab: AlertTab): string {
  return `${ALERTS_PATH}/${tab}`;
}
